export enum NotificationStatus {
  Scheduled = 'scheduled',
  Sent = 'sent',
  Failed = 'failed',
  Cancelled = 'cancelled',
  Read = 'read',
  Unknown = 'unknown'
}

export const mapper: Record<NotificationStatus, string> = {
  [NotificationStatus.Scheduled]: 'Scheduled',
  [NotificationStatus.Sent]: 'Sent',
  [NotificationStatus.Failed]: 'Failed',
  [NotificationStatus.Cancelled]: 'Cancelled',
  [NotificationStatus.Read]: 'Read',
  [NotificationStatus.Unknown]: 'Unknown'
}
